export default __webpack_public_path__ + "static/media/3.7bc2b5b5.mp4";